<template>
  <main @touchmove.prevent>
    <div class="poster_wrap" v-if="getGuideEvaluationPopup.isShow">
      <div class="poster_box">
        <div class="advantage_tc">
          <div class="advantage_img">
            <van-image class="picMain" :src="youpPath + imageUrl" @load="handelLoad" />
            <div ref="numBox" class="numBox">
              <span v-text="getGuideEvaluationPopup.RewardFreeCard" class="num"></span>
              <span class="unit">张</span>
            </div>
            <div class="goToBalanceWithdraw tapActive" @click="routerHandler('balanceWithdraw')"></div>
            <div class="goToInvitationEvaluation tapActive" @click="routerHandler('invitationEvaluation')"></div>
          </div>
        </div>
        <div class="icon-small-wrp close_icon">
          <i class="iconfont icon-guanbi" @click="close"></i>
        </div>
      </div>
      <template v-if="!isHomeTab">
        <div class="sh-dialog-mask" @click="close"></div>
      </template>
    </div>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      youpPath: IMG_BASE_URL,
      imageUrl: '/upaiyun/Sys/20220506/5110847893367259032.png'
    }
  },
  props: {
    // 是否在有tab栏的页面展示弹窗
    isHomeTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getGuideEvaluationPopup'])
  },
  methods: {
    ...mapMutations(['SET_GUIDE_EVALUATION_POPUP']),
    handelLoad() {
      this.$nextTick(() => {
        this.$refs.numBox.style.visibility = 'visible'
      })
    },
    close() {
      this.SET_GUIDE_EVALUATION_POPUP({
        isShow: false,
        RewardFreeCard: 0
      })
    },
    routerHandler(routerName) {
      this.$router.push(routerName)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.poster_wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  font-size: 15px;
  z-index: 91;
}
.poster_box {
  position: absolute;
  width: vw(262.5);
  height: vw(339);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  z-index: 99;
}
.advantage_tc {
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  z-index: 99;
  overflow: hidden;
}
.advantage_img {
  position: relative;
  .picMain {
    width: vw(262.5);
    height: vw(339);
  }
  .numBox {
    // display: none;
    position: absolute;
    top: vw(166);
    right: vw(48);
    color: red;
    font-size: vw(18);
    // opacity: 0;
    visibility: hidden;
    .num {
      font-size: vw(24);
      margin-right: vw(4);
      font-weight: 700;
    }
  }
  .goToBalanceWithdraw {
    position: absolute;
    width: vw(90);
    height: vw(36);
    bottom: vw(28);
    left: vw(30);
  }
  .goToInvitationEvaluation {
    position: absolute;
    width: vw(90);
    height: vw(36);
    bottom: vw(28);
    right: vw(31);
  }
}
.advantage_img img {
  width: 100%;
  display: block;
}
.advantage_txt p {
  display: block;
  font-size: 16px;
  height: 24px;
}
.t_ff7f7e {
  color: #ff7f7e;
}
.btn_ff7ff3 {
  position: relative;
  background: #ff7f7e;
  color: #fff;
  border-radius: 5px;
  height: 34px;
  line-height: 34px;
  width: 150px;
  margin: 15px auto 0;
}
.btn_pd {
  padding-bottom: 20px;
}
.btn_ff7ff3 button {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.close_icon {
  text-align: center;
  margin-top: 10px;
  z-index: 99;
  color: #fff;
  position: relative;
}
.close_icon i {
  font-size: 28px;
}
.btn-hover-class {
  opacity: 0.8;
}
</style>
